import { render, staticRenderFns } from "./assessment.vue?vue&type=template&id=241ee8c1&scoped=true"
import script from "./assessment.vue?vue&type=script&lang=js"
export * from "./assessment.vue?vue&type=script&lang=js"
import style0 from "./assessment.vue?vue&type=style&index=0&id=241ee8c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ee8c1",
  null
  
)

export default component.exports